import { OrderMenuSet } from 'earn-ts/build/rust';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoTrashOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/store';
import Loader from 'src/components/Loader';
import Button from 'src/components/Order/Button';
import Header from 'src/components/Order/HeaderComponent';
import MenuSetItemOrder from 'src/components/Order/MenuSetItemOrder';
import PageHeader from 'src/components/Order/PageHeader';
import QuantityItem from 'src/components/Order/QuantityItem';
import {
  canModifySelectedMenus,
  incrementSet,
  onClearCart,
  onEditMenu,
  setDraftSet,
} from 'src/reducer/order/orderReducer';
import { submitOrderSets } from 'src/utils/orderFunc';
import { toast } from 'react-toastify';
import { ELoadOrderStatus } from 'src/reducer/order/types';
import { genErrorMessage } from 'src/utils';

let counter = 0;

export default function OrderCheckout() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['main']);

  const [ordering, setOrdering] = useState(false);

  const { language } = useTranslation(['main']).i18n;

  const handleBack = () => {
    navigate(-1);
  };

  const appState = useAppSelector(state => state.order);
  const submittingStatus = useAppSelector(
    state => state.order.submittingStatus,
  );
  const dataSelectedMenus = useAppSelector(
    state => state.order.dataSelectedMenus,
  );
  const { shopId } = appState;

  counter += 1;
  console.log('OrderCheckout re-render', counter);

  const handlePlaceOrder = async () => {
    if (submittingStatus === ELoadOrderStatus.Pending) {
      toast.warning(t('order-pending-warning'));
      return;
    }
    setOrdering(true);
    const action = await submitOrderSets(appState);
    if (action == null) return;
    try {
      await dispatch(action).unwrap();
      navigate('../orderConfirm', {
        relative: 'path',
      });
      clearAllMenus();
    } catch (error) {
      const err = error as Error;
      toast.error(genErrorMessage(t, err?.message));
    } finally {
      setOrdering(false);
    }
  };

  const increase = (id: string) => {
    if (!canModifySelectedMenus(appState)) return;
    dispatch(incrementSet({ delta: +1, setId: id }));

    // todo need to update price?
    //handleUpdatePrice(id, menuItemQuantity);
  };

  const decrease = (id: string) => {
    if (!canModifySelectedMenus(appState)) return;
    dispatch(incrementSet({ delta: -1, setId: id }));
    // todo need to update price?
    //handleUpdatePrice(id, menuItemQuantity);
  };

  const handleEditMenuSet = async (item: OrderMenuSet, index: number) => {
    if (!canModifySelectedMenus(appState)) return;
    dispatch(setDraftSet(item));

    dispatch(onEditMenu(true));
    navigate('../listFoodSet', {
      relative: 'path',
    });
  };

  const clearAllMenus = () => {
    dispatch(onClearCart());
  };
  const menuSelectedQuantity = dataSelectedMenus.length;
  return (
    <div>
      <div className="top-0 z-20 left-0 fixed px-[15px] pt-[5px] w-full scroll-smooth font-medium shadow-md bg-white">
        <Header
          title={`Table: ${appState.fullOrder?.table?.table_id ?? '-'}`}
          isShowBack={true}
          onPressBack={handleBack}
          isShowMenu={false}
          isHideHomeIcon={true}
        />
        <button
          className="absolute top-2.5 right-5 text-[14px] flex z-20"
          onClick={() => clearAllMenus()}>
          <IoTrashOutline className="cursor-pointer mr-1" fontSize={22} />
          <span className="font-normal mt-0.5">Clear All</span>
        </button>
      </div>
      <div className="font-medium grow pt-[10px] mb-5 w-full overflow-y-auto mt-[60px]">
        <PageHeader title={'Items'} />
        <div className="w-full pb-4">
          {dataSelectedMenus?.map((item, index) => (
            <div
              onClick={() => handleEditMenuSet(item, index)}
              className="w-full pb-4 pt-4 border-b-[1px] border-shadow-3 border-solid bg-white"
              key={index}>
              <MenuSetItemOrder item={item} lang={language} key={index} />
              {item.comment && (
                <div className="px-4 py-3 font-normal">
                  <p className="">Remarks: </p>
                  <p className="pl-3 text-sm pt-1 text-shadow-5">
                    {item.comment}
                  </p>
                </div>
              )}
              <div className="font-medium flex flex-row justify-between	mt-3 px-[15px]">
                {canModifySelectedMenus(appState) && (
                  <QuantityItem
                    id={''}
                    value={item.quantity}
                    name="edit"
                    handleIncrease={e => {
                      e.stopPropagation();
                      increase(item.id);
                    }}
                    handleDecrease={e => {
                      e.stopPropagation();
                      decrease(item.id);
                    }}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t-[1.5px] border-solid border-shadow-2 bg-white pt-5 pb-5 fixed bottom-0 left-0 w-full px-[5%]">
        <Button
          className={`px-5 w-full py-2 text-[16px] ${
            submittingStatus != null && 'bg-blue'
          } ${!menuSelectedQuantity ? 'bg-shadow-3' : ''}`}
          onClick={handlePlaceOrder}
          label="Place Order"
          disabled={!menuSelectedQuantity}
        />
      </div>
      {ordering && <Loader loadingText="Ordering" />}
    </div>
  );
}
